import React, {useState} from 'react';
import {CustomSeparator, Footer,  TopNavBar} from '../../components'
import {withRouter} from "react-router-dom";
import { OrderPlaced} from '../../components'
import Seo from "../../components/Seo";

function Index(props) {

  const [breadCrumbsList, setBreadCrumbsList] = React.useState([
    {text: 'home', url: ''},
    {text: 'profile ', url: ''},
    {text: 'products ', url: ''},
  ]);
   const onSearchClick = (item,category) => {
     props.history.push({
      pathname: '/result',
      state: {search: item, category: category}
    })
  }

  return (
    <>
      <Seo
        title="Products"
        description="Browse verified agricultural products on AgriLive's fair, traceable marketplace."
        path="/products"
      />
      <TopNavBar onClick={onSearchClick}/>
      <div className='p-main'>
        <CustomSeparator breadCrumbsList={breadCrumbsList}{...props} setBreadCrumbsList={setBreadCrumbsList}/>
      </div>
      <div className='content-container ' style={{marginBottom:40}}>
        <OrderPlaced/>
      </div>
      <Footer/>
    </>
  );
}

export default withRouter(Index);
